<form [formGroup]="imageForm" (ngSubmit)="insertImageLink()">
  <input
    #insertImageInput
    formControlName="imageLink"
    type="url"
    [placeholder]="'bcEditor.insertImageLinkPlaceholder' | translate"
    [class.validate]="imageLink.invalid && imageLink.dirty"
    data-automation-id="gc-editor-insert-image-input"
  />
  <button
    type="submit"
    class="btn btn-light"
    [class.validate]="imageLink.invalid && imageLink.dirty"
    data-automation-id="gc-editor-insert-image-button"
    [disabled]="imageLink.invalid && imageLink.dirty"
  >
    {{ 'bcEditor.insertImage' | translate }}
  </button>
</form>
